import Axios, {AxiosResponse} from "axios";
import {IShippingInfoRequestDto} from "../models/shipping/shipping-info";
import RootApi from "./root-api";

export default class ShippingApi extends RootApi {
    private readonly apiEndpoint: string = this.ApiRoot + '/shipping';

    public async searchMethods(request: IShippingInfoRequestDto): Promise<AxiosResponse> {
        return await Axios.post(`${this.apiEndpoint}/methods/search`, request);
    }

    public async getShippingInfo(request: IShippingInfoRequestDto): Promise<AxiosResponse> {
        return await Axios.post(`${this.apiEndpoint}/info`, request);
    }

    public async getDestinationsByMethod(countryId: number, methodId: number): Promise<AxiosResponse> {
        return await Axios.get(`${this.apiEndpoint}/destinations?countryid=${countryId}&methodid=${methodId}`);
    }
}



// WEBPACK FOOTER //
// ./src/api/shipping-api.ts